export default "__VITE_ASSET__D$dQyYlH__"